import { Fetcher } from "../fetcher";
import { 
  FilterTemplate, 
  CreateFilterTemplateDto, 
  UpdateFilterTemplateDto 
} from "./types";

/**
 * Repository for Filter Template operations.
 */
export function createFilterTemplatesRepository(fetcher: Fetcher) {
  return {
    /**
     * Get all filter templates for a specific context
     */
    list: async (context: string): Promise<FilterTemplate[]> => {
      return await fetcher<FilterTemplate[]>("/filter-templates", {
        params: { context },
      });
    },

    /**
     * Create a new filter template
     */
    create: async (dto: CreateFilterTemplateDto): Promise<FilterTemplate> => {
      return await fetcher<FilterTemplate>("/filter-templates", {
        method: "POST",
        body: JSON.stringify(dto),
      });
    },

    /**
     * Update an existing filter template
     */
    update: async (id: string, dto: UpdateFilterTemplateDto): Promise<FilterTemplate> => {
      return await fetcher<FilterTemplate>(`/filter-templates/${id}`, {
        method: "PATCH",
        body: JSON.stringify(dto),
      });
    },

    /**
     * Delete a filter template
     */
    delete: async (id: string): Promise<void> => {
      await fetcher(`/filter-templates/${id}`, {
        method: "DELETE",
      });
    },
  };
}
